import React, {PropsWithChildren} from 'react';
import {View, Text, ViewStyle} from 'react-native';

import {theme} from '../../constants';
import {ProductType} from '../../types';
import {hasPositiveWeight} from '../../utils/product';
import {formatCurrency} from '../../utils/currency';

type Props = PropsWithChildren<{
  gram?: boolean;
  item: ProductType;
  containerStyle?: ViewStyle;
  numberOfLines?: number;
}>;

const ProductPrice: React.FC<Props> = ({
  gram,
  item,
  containerStyle,
  numberOfLines = 1,
}): JSX.Element => {
  const shouldShowWeight = gram && hasPositiveWeight(item.weight);
  const priceContainerStyle: ViewStyle = {
    flexDirection: 'row',
    alignItems: 'center',
    paddingRight: 30,
    ...containerStyle,
  };

  const shouldShowOldPrice =
    typeof item.oldPrice === 'number' && item.oldPrice > item.price;

  return (
    <View style={priceContainerStyle}>
      {shouldShowOldPrice && typeof item.oldPrice === 'number' && (
        <Text
          style={{
            marginRight: 8,
            minWidth: 30,
            textDecorationLine: 'line-through',
            ...theme.fonts.DMSans_400Regular,
            fontSize: 12,
            color: theme.colors.textMuted,
            lineHeight: 12 * 1.5,
          }}
        >
          {formatCurrency(item.oldPrice)}
        </Text>
      )}
      <Text
        style={{
          ...theme.fonts.DMSans_500Medium,
          fontSize: 14,
          lineHeight: 14 * 1.5,
          color: theme.colors.textPrimary,
          minWidth: 30,
        }}
        numberOfLines={numberOfLines}
      >
        {formatCurrency(item.price)}
      </Text>
      {shouldShowWeight && (
        <React.Fragment>
          <View
            style={{
              width: 1,
              height: 10,
              backgroundColor: '#D5DCE3',
              marginHorizontal: 8,
            }}
          />
          <Text
            style={{
              ...theme.fonts.DMSans_400Regular,
              fontSize: 10,
              color: theme.colors.textMuted,
            }}
          >
            {`${item.weight}g`}
          </Text>
        </React.Fragment>
      )}
    </View>
  );
};

export default ProductPrice;
